import { render, staticRenderFns } from "./OrderCheckoutTacographCertificateRenewal.vue?vue&type=template&id=423a4b64"
import script from "./OrderCheckoutTacographCertificateRenewal.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutTacographCertificateRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports